import { aboutVoices } from '@/mocks/site';

export default function VoicesSection() {
  return (
    <section id="voices" className="w-full bg-secondary-50 border-y border-secondary-200 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <p className="font-label text-xs tracking-[0.25em] text-secondary-700 mb-3">
              WHY IT MATTERS / 发展理念
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              我们想让「看清」这件事变得容易一点
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              短剧越来越快，观众留给判断的时间越来越少。我们不指望替谁做结论，只希望能把判断所需的材料准备好——把一句模糊的宣传语，换成一张能对照的表。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              这件事本身不赚钱也不热门，但它值得有人认真做。只要还有观众愿意在看剧前多问一句「这是真的吗」，这份档案就有存在的必要。
            </p>
          </div>

          <div className="lg:col-span-7">
            <p className="font-label text-xs text-foreground-500 mb-4">读者反馈摘录</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <figure className="flex flex-col p-5 rounded-lg bg-background-50 border border-secondary-200">
                <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
                <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">
                  {aboutVoices[0].quote}
                </blockquote>
                <figcaption className="mt-5 pt-4 border-t border-background-200">
                  <p className="font-heading text-sm font-bold text-foreground-950">
                    {aboutVoices[0].name}
                  </p>
                  <p className="mt-0.5 text-xs text-foreground-500">{aboutVoices[0].role}</p>
                </figcaption>
              </figure>

              <div className="flex flex-col gap-4">
                {aboutVoices.slice(1).map((item) => (
                  <figure
                    key={item.name}
                    className="flex-1 p-5 rounded-lg bg-background-50 border border-secondary-200"
                  >
                    <blockquote className="text-sm text-foreground-700 leading-relaxed">
                      {item.quote}
                    </blockquote>
                    <figcaption className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="font-heading font-bold text-foreground-900">
                        {item.name}
                      </span>
                      <span>·</span>
                      <span>{item.role}</span>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}